<template>
  <div v-if="visible" class="modal-overlay" @click.self="close">
    <div class="modal-remove" @click.stop>
      <div class="modal-content">
        <div class="warning-icon">
          <i class="icon-warning">!</i>
        </div>
          <h2 class="modal-title">Excluir a sequência do agendamento recorrente?</h2>
          <p class="modal-description">
            Você está prestes a excluir uma sequência de transferências Pix agendadas no valor de
            <strong>R$ {{ formatAmount(recurrence.amount) }}</strong> para
            <strong>{{ recurrence.accountDestinationName }}</strong>
            <span v-if="recurrence.accountDestinationTaxDocument">
              ({{ maskDocument(recurrence.accountDestinationTaxDocument) }})
            </span>
            e essa ação não pode ser desfeita.
          </p>
          <div class="warning-box">
            <p>
              <strong>Essa ação não afeta nenhuma transferência Pix da sequência que já tenha sido realizada.</strong>
            </p>
          </div>
      </div>

      <div class="modal-actions">
        <button class="btn-cancel" @click="close">
          Cancelar
        </button>
        <button class="btn-delete" @click="confirmDelete">
          Excluir
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppRemoveRecurrence',
  props: {
    recurrence: {
      type: Object,
      default: () => ({
        amount: 0,
        accountDestinationName: 'N/A',
        accountDestinationTaxDocument: '',
      }),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirmDelete() {
      this.$emit('confirm-delete', this.recurrence);
      this.close();
    },
    formatAmount(amount) {
      if (!amount) return '0,00';
      return amount.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    maskDocument(document) {
      if (!document) return '';

      const cleanDoc = document.replace(/\D/g, '');

      if (cleanDoc.length === 11) {
        return `${cleanDoc.substring(0, 3)}.***.**-${cleanDoc.substring(9, 11)}`;
      } else if (cleanDoc.length === 14) {
        return `${cleanDoc.substring(0, 2)}.${cleanDoc.substring(2, 5)}.***/**-${cleanDoc.substring(12, 14)}`;
      }

      return document.length > 10
        ? `${document.substring(0, 3)}***${document.substring(document.length - 2)}`
        : document;
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-remove {
  background: white;
  border-radius: 12px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.modal-content {
  padding: 32px 24px 24px;
  text-align: center;
}

.warning-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #dc3545;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 24px;
  font-weight: bold;
}

.icon-warning {
  font-style: normal;
  font-weight: bold;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px;
  line-height: 1.4;
}

.modal-description {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0 0 16px;
  text-align: left;
}

.warning-box {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  padding: 12px;
  margin: 16px 0 0;
}

.warning-box p {
  margin: 0;
  font-size: 13px;
  color: #856404;
  text-align: left;
}

.modal-actions {
  padding: 16px 24px;
  background: #f8f9fa;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-cancel,
.btn-delete {
  padding: 10px 24px;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 80px;
}

.btn-cancel {
  background: transparent;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.btn-cancel:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.btn-delete {
  background: #dc3545;
  color: white;
}

.btn-delete:hover {
  background: #c82333;
}

.btn-delete:active {
  background: #bd2130;
}
</style>
